/**
 * Utilitaires de validation pour les prix
 */

// Pattern de validation pour les prix (nombre entier ou décimal avec max 3 décimales)
// Accepte: 5, 10, 5.5, 5,5, 12.99, 12,99, 100.000, 100,000, 5.123, 5,123
// Rejette: -5, 5.1234, 1e5, abc, 5., 5,
export const PRICE_INPUT_PATTERN = '^[0-9]+([.,][0-9]{1,3})?$';
export const PRICE_INPUT_TITLE =
  'Entrez un prix valide (ex: 5.50 ou 5,50, 12.999, 100)';

/**
 * Valide qu'un prix textuel respecte le format attendu
 * @param priceText - Le prix sous forme de texte
 * @returns true si le format est valide, false sinon
 */
export const isValidPriceFormat = (priceText: string): boolean => {
  const pricePattern = new RegExp(PRICE_INPUT_PATTERN);
  return pricePattern.test(priceText);
};

/**
 * Valide et parse un prix textuel
 * @param priceText - Le prix sous forme de texte
 * @returns Le prix en nombre si valide, null si invalide
 */
export const parseValidPrice = (priceText: string): number | null => {
  if (!isValidPriceFormat(priceText)) {
    return null;
  }

  // Normaliser les virgules en points pour le parsing
  const normalizedText = priceText.replace(',', '.');
  const price = parseFloat(normalizedText);
  if (isNaN(price) || price < 0) {
    return null;
  }

  return price;
};
